import React from 'react'
import Appbar from './Appbar'
import Sidebar from './Sidebar'
import { Button, Grid, OutlinedInput, Paper } from '@mui/material';
import "../Assets/CSS/BnbConnect.css"
import { useNavigate } from 'react-router-dom';

const BuyBnbConnect = () => {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const navigate = useNavigate();
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    return (
        <div className='bnbcontainer'>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <Appbar handleDrawerToggle={handleDrawerToggle} />
                </Grid>

                <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                        <Grid item md={2} sm={3}>
                            <Sidebar open={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
                        </Grid>
                        <Grid item xs={12} sm={9} md={10} sx={{ mt: "70px" }}>
                            <Grid container spacing={3} p={3}>
                                <Grid item xs={12} md={12}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white", padding: "15px", borderRadius: "10px" }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <div className='headerconn'>
                                                    <div className='dashbheading'
                                                        onClick={() => {
                                                            navigate("/dashboard")
                                                        }}
                                                    >Dashboard</div>
                                                    <div className='subheading'>
                                                        / Buy BNB Connect
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white", borderRadius: "20px" }}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} md={12} >
                                                <div className='topuptitle'>Buy BNB Connect</div>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <hr />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Grid container spacing={2} sx={{ paddingLeft: "30px", paddingRight: "30px", paddingBottom: "30px" }}>
                                                    <Grid item xs={12} md={12}>
                                                        <div className='title'>
                                                            Wallet Balance
                                                        </div>
                                                        <OutlinedInput
                                                            placeholder="0.0158 BNB"
                                                            className="whiteInput"
                                                            id="outlined-adornment-amount"
                                                            fullWidth
                                                            size='small' />
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <div className='title'>
                                                            Enter Amount
                                                        </div>
                                                        <OutlinedInput
                                                            className="whiteInput"
                                                            placeholder="Enter Amount"
                                                            fullWidth
                                                            size='small' />
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Button variant="contained"
                                                            sx={{
                                                                border: "none",
                                                                color: "#fff",
                                                                fontSize: "16px",
                                                                borderRadius: "10px"
                                                            }}
                                                            className='copybtn'
                                                        >Submit</Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default BuyBnbConnect